export const DefaultMorphingAnimateConfig = {
    duration: 1e3,
    easing: "quadInOut"
};
//# sourceMappingURL=morphing.js.map